// extracted by css-extract-rspack-plugin
export default {"link":"Link-module__link___njbxO"};